import Localizer from "@/localization/Localizer";
import CypressDropdownHelper from "@/helpers/CypressDropdownHelper";
import {executeWithIntercept, onRedirect, pageData, RouteData} from "@/helpers/CypressHelper";
import CypressFeatureFlagService from "@/helpers/CypressFeatureFlagService";
import RentaEasyConstants from "@/helpers/RentaEasyConstants";
import TagManagerHelper, {GtmEvents} from "@/helpers/TagManagerHelper";

describe('Desktop - Shopping Cart', () => {

    describe('Elements tests - Site User', () => {
        beforeEach(() => {
            cy.session(['construction_site_role_session'], () => {
                cy.loginAndSelectCompanyRole("cs.user@domain.fi", "ConstructionSite1");
            });
        });

        it('Should have site role selected in the dropdown', () => {
            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCart.json'});

            redirectToShoppingCart(true);

            cy.get('#construction-site-selection .athenaeum-dropdown-itemsList')
                .children('.athenaeum-dropdown-item')
                .find('span')
                .should('contain.text', 'ConstructionSite1');
        });
    });
    describe('Elements tests - Company User', () => {

        before(() => {
        });

        beforeEach(() => {
            cy.session(['company_role_session'], () => {
                cy.loginAndSelectCompanyRole("Urho.Kekkonen@weare.fi", "tmi jukka wilska");
            });

            cy.intercept('POST', '/api/ConstructionSites/GetContractsConstructionSites', {fixture: 'shoppingCart/getContractsConstructionSites.json'});
            cy.intercept('POST', '/api/ConstructionSites/GetConstructionSites', {fixture: 'shoppingCart/getConstructionSites.json'});
        });

        it('should fire GTM event for viewing cart', () => {
            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCart.json'});

            redirectToShoppingCart(true);

            TagManagerHelper.validateGtmEvent(GtmEvents.VIEW_CART);
        });

        it('should render the shopping cart with related products', () => {
            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCart.json'});

            redirectToShoppingCart();

            pageData().shoppingCart.startTimeInput()
                .should('not.exist');

            cy.get('h3')
                .should('contain', Localizer.productDetailsAccessories);

            cy.get('.swiper-slide')
                .should('have.length', 7);

        });

        it('should display rental start time when feature flag is set to true', () => {
            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagShoppingCartStartTime, enabled: true},
            ]);

            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCartOneItem.json'});

            redirectToShoppingCart();

            CypressDropdownHelper.openAndSelectDropdownItemByIndex("#shopping_cart_start_time", 4);

            pageData().shoppingCart.startTimeInput()
                .find('.selected-item')
                .should('contain.text', '02:00');

            fillOrder();

            sendOrder();

            cy.intercept('POST', '/api/Product/OrderDetails', {fixture: 'orderDetails.json'});
        });

        it('should change price for a selected construction site', () => {
            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCartOneItem.json'});

            redirectToShoppingCart();

            // Default price.
            pageData().rent.product.price()
                .should('contain.text', '485,63');

            pageData().rent.shoppingCart.companyDropDown().should("exist");

            cy.intercept('POST', '/api/ConstructionSites/GetConstructionSiteDiscounts', {fixture: 'getConstructionSiteDiscounts.json'});

            // Select different Construction Site.
            CypressDropdownHelper.openAndSelectDropdownItemByIndex("#construction-site-selection", 2);

            // Price for a different construction site.
            pageData().rent.product.price()
                .should('contain.text', '664,40');

            fillOrder();
            sendOrder();

            cy.intercept('POST', '/api/Product/OrderDetails', {fixture: 'orderDetails.json'});

            pageData().rent.product.price()
                .should('contain.text', '664,40');

        });

        it('should render the shopping cart with invoice reference, delivery contact, construction site external reference, construction sites dropdown including external id, and night delivery', () => {
            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagShoppingCartInvoiceReference, enabled: true},
                {flagName: RentaEasyConstants.featureFlagShoppingCartDeliveryContact, enabled: true},
                {flagName: RentaEasyConstants.featureFlagShoppingCartConstructionSiteExternalReference, enabled: true},
                {flagName: RentaEasyConstants.featureFlagShoppingCartConstructionSitesDropdownIncludingExternalId, enabled: true},
                {flagName: RentaEasyConstants.featureFlagShoppingCartConstructionSitesDropdownIncludingStatuses, enabled: true},
                {flagName: RentaEasyConstants.featureFlagShoppingCartNightDelivery, enabled: true},
            ]);

            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCartOneItem.json'});

            redirectToShoppingCart();

            // invoice reference, delivery contact, and construction site external reference inputs are visible
            pageData().rent.shoppingCart.invoiceReferenceInput().should('exist');
            pageData().rent.shoppingCart.deliveryContactInput().should('exist');
            pageData().rent.shoppingCart.constructionSiteExternalReferenceInput().should('exist');

            // construction site dropdown contains proper group name
            cy.get('#construction-site-selection .athenaeum-dropdown-group').children('div').find('span').should('contain.text', Localizer.constructionSitesNonActive);

            // subtext should contain external reference and external id
            cy.get('#construction-site-selection .athenaeum-dropdown-itemsList').children('.athenaeum-dropdown-item').find('small').should('contain.text', 'TestSite7ExternalReference TestSite7ExternalId');

            // select delivery to the site
            CypressDropdownHelper.openAndSelectDropdownItemByIndex("#shopping_cart_dropdown_delivery_type", 0);

            // night delivery is visible
            pageData().rent.shoppingCart.nightDeliveryCheckbox().should('exist');
        });

        it('should render the shopping cart with construction sites dropdown without statuses when ShoppingCartConstructionSitesDropdownIncludingStatuses is disabled', () => {
            pageData().common.interceptFeatureFlags([
                {flagName: RentaEasyConstants.featureFlagShoppingCartConstructionSitesDropdownIncludingStatuses, enabled: false},
            ]);

            cy.intercept('POST', '/api/ShoppingCart/GetShoppingCart', {fixture: 'getShoppingCartOneItem.json'});

            redirectToShoppingCart();

            // subtext should contain proper group name
            cy.get('#construction-site-selection .athenaeum-dropdown-group').children('div').find('span').should('contain.text', Localizer.constructionsites);
        });

        function fillOrder() {
            // Populate address related fields
            pageData().shoppingCart.address().focus().type("Test 1");
            pageData().shoppingCart.postalCode().focus().type("12345");
            pageData().shoppingCart.city().focus().type("Test");

            // Select the first available delivery type
            CypressDropdownHelper.openAndSelectDropdownItemByIndex("#shopping_cart_dropdown_delivery_type", 0);

            // Select the first available depot
            CypressDropdownHelper.openAndSelectDropdownItemByIndex("#shopping_cart_dropdown_depot", 0);

            // Select first available start day
            pageData().shoppingCart.dateInputFrom()
                .click()
                .find(".react-datepicker__day")
                .not('.react-datepicker__day--outside-month')
                .not('.react-datepicker__day--disabled')
                .first()
                .click();

            pageData().shoppingCart.dateInputFrom()
                .should('not.be.empty');

            //Select end date from a next month.
            pageData().shoppingCart.dateInputTo()
                .click();

            cy.get('.react-datepicker__navigation--next')
                .click();

            cy.get('.react-datepicker__day')
                .not('.react-datepicker__day--outside-month')
                .not('.react-datepicker__day--disabled')
                .first()
                .click();

            pageData().shoppingCart.dateInputTo()
                .should('not.be.empty');

            cy.get("#shopping_cart_submit").trigger('click');
        }

        function sendOrder() {
            executeWithIntercept(() =>
                    pageData().shoppingCart.confirmationDialog()
                        .click(),
                [pageData().shoppingCart.routes.sendOrder as RouteData]);
        }
    });

    function redirectToShoppingCart(waitForConstructionSites: boolean = false): void {
        let routes = [
            pageData().common.routes.depots as RouteData,
        ];

        if (waitForConstructionSites) {
            routes.push(pageData().constructionSites.routes.sitesForContract as RouteData);
        }

        onRedirect(() => executeWithIntercept(() => cy.visit("/ShoppingCart"),
            routes));
    }

});